(function () {
  'use strict';

  /* Reveal on scroll */
  var reveals = document.querySelectorAll('.cc-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Back to top */
  var top = document.querySelector('[data-back-to-top]');
  if (top) {
    var onScroll = function () { top.classList.toggle('is-visible', window.scrollY > 480); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    top.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    });
  }

  /* Close open dropdowns on outside click / Escape */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-dropdown][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-dropdown][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary'); if (s) s.focus();
    });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = Math.max(parseInt(input.min || 1, 10), v + parseInt(b.dataset.step, 10));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Product variant picker */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('script[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-product-form]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var mainImg = root.querySelector('[data-main-image]');
    var thumbs = root.querySelector('[data-thumbs]');
    var addBtn = form.querySelector('[data-add]');
    var metalIndex = product.options.indexOf('Metal');

    function money(cents) {
      var v = cents / 100;
      var s = v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return product.currency_symbol + s;
    }
    function selected() {
      return product.options.map(function (name, i) {
        var radio = root.querySelector('[data-option-index="' + i + '"]:checked');
        if (radio) return radio.value;
        var sel = root.querySelector('select[data-option-index="' + i + '"]');
        return sel ? sel.value : null;
      });
    }
    function findVariant(vals) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
    }
    function showImage(src, alt) {
      if (!mainImg || !src) return;
      mainImg.style.opacity = 0;
      var img = new Image();
      img.onload = function () {
        mainImg.src = src; mainImg.removeAttribute('srcset');
        if (alt) mainImg.alt = alt;
        mainImg.style.opacity = 1;
      };
      img.src = src;
    }
    function sized(url, w) {
      if (!url) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function renderGallery(vals) {
      var imgs = product.images || [];
      var keys = (vals || []).filter(function (x) { return x && x !== 'Default Title'; }).map(function (x) { return x.toLowerCase(); });
      if (keys.length) {
        var f = imgs.filter(function (m) { var a = (m.alt || '').toLowerCase(); return keys.every(function (k) { return a.indexOf(k) > -1; }); });
        if (f.length) imgs = f;
      }
      thumbs.innerHTML = '';
      if (imgs.length < 2) return;
      imgs.forEach(function (m, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', m.alt || ('Image ' + (idx + 1)));
        b.setAttribute('aria-pressed', idx === 0 ? 'true' : 'false');
        var i = document.createElement('img');
        i.src = sized(m.src, 240); i.alt = ''; i.loading = 'lazy';
        b.appendChild(i);
        b.addEventListener('click', function () {
          showImage(sized(m.src, 1600), m.alt);
          thumbs.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
        thumbs.appendChild(b);
      });
    }
    function renderThumbs(vals, current) {
      if (!thumbs) return;
      if (metalIndex < 0) { renderGallery(vals); return; }
      var seen = {};
      var items = product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return i === metalIndex || o === vals[i]; }) && v.image;
      }).filter(function (v) { if (seen[v.image]) return false; seen[v.image] = 1; return true; });
      thumbs.innerHTML = '';
      if (items.length < 2) return;
      items.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', v.options[metalIndex]);
        b.setAttribute('aria-pressed', v.id === current.id ? 'true' : 'false');
        var i = document.createElement('img');
        i.src = sized(v.image, 240); i.alt = ''; i.loading = 'lazy';
        b.appendChild(i);
        b.addEventListener('click', function () {
          var r = root.querySelector('[data-option-index="' + metalIndex + '"][value="' + CSS.escape(v.options[metalIndex]) + '"]');
          if (r) { r.checked = true; update(); }
        });
        thumbs.appendChild(b);
      });
    }
    function setOption(i, value) {
      var r = root.querySelector('[data-option-index="' + i + '"][value="' + CSS.escape(value) + '"]');
      if (r) { r.checked = true; return; }
      var sel = root.querySelector('select[data-option-index="' + i + '"]');
      if (sel) sel.value = value;
    }
    function update(e) {
      var vals = selected();
      if (!findVariant(vals) && e && e.target && e.target.dataset) {
        var ci = parseInt(e.target.dataset.optionIndex, 10);
        var alt = product.variants.find(function (v) { return v.options[ci] === vals[ci]; });
        if (alt) { alt.options.forEach(function (o, i) { setOption(i, o); }); vals = selected(); }
      }
      root.querySelectorAll('[data-option-value]').forEach(function (el) {
        el.textContent = vals[parseInt(el.dataset.optionValue, 10)] || '';
      });
      var v = findVariant(vals);
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable;
        return;
      }
      idInput.value = v.id;
      if (v.available) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.add; }
      else { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.soldOut || 'Sold out'; }
      var made = root.querySelector('.cc-made'); if (made) made.hidden = !(v.available && v.mto);
      var badge = root.querySelector('[data-mto-badge]');
      if (badge) { if (!v.available) { badge.textContent = badge.dataset.sold; badge.hidden = false; } else if (v.mto) { badge.textContent = badge.dataset.mto; badge.hidden = false; } else { badge.hidden = true; } }
      if (priceEl) priceEl.textContent = money(v.price);
      if (v.image) showImage(sized(v.image, 1600), v.image_alt);
      renderThumbs(vals, v);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('[data-option-index]').forEach(function (el) {
      el.addEventListener('change', update);
    });

    /* Engraving fee: add the fee product alongside the piece when text is entered */
    var engrave = root.querySelector('[data-engrave]');
    if (engrave && engrave.dataset.feeId) {
      var engraveInput = engrave.querySelector('[data-engrave-input]');
      var titleEl = root.querySelector('.cc-product__title');
      form.addEventListener('submit', function (e) {
        var text = (engraveInput.value || '').trim();
        if (!text || !window.fetch) return;
        e.preventDefault();
        var qtyEl = form.querySelector('input[name="quantity"]');
        var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var vEl = form.querySelector('input[name="id"]');
        var label = (titleEl ? titleEl.textContent.trim() : 'piece');
        var chosen = selected().filter(Boolean).join(' / ');
        if (chosen) label += ' (' + chosen + ')';
        addBtn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [
            { id: parseInt(vEl.value, 10), quantity: qty, properties: { Engraving: text } },
            { id: parseInt(engrave.dataset.feeId, 10), quantity: qty, properties: { _engraving_fee: '1', _for: label, _text: text } }
          ] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }).catch(function () {
          addBtn.disabled = false;
          form.submit();
        });
      });
    }
    var initial = findVariant(selected());
    renderThumbs(selected(), initial || product.variants[0]);
  });



  /* Pop-out layers over cover-fit photos: place them by the photo's rendered geometry */
  var covers = Array.prototype.slice.call(document.querySelectorAll('.cc-pop-wrap[data-pop]'));
  function placeCovers() {
    covers.forEach(function (wrap) {
      var box = wrap.parentElement;
      var base = box.querySelector('.cc-pop-base');
      if (!base || !base.naturalWidth) return;
      var f = wrap.dataset.pop.split(',').map(parseFloat); // left, top, width (fractions of the photo)
      var pos = (base.dataset.pos || '50% 50%').split(/\s+/).map(function (v) { return parseFloat(v) / 100; });
      var bw = box.clientWidth, bh = box.clientHeight;
      var sc = Math.max(bw / base.naturalWidth, bh / base.naturalHeight);
      var iw = base.naturalWidth * sc, ih = base.naturalHeight * sc;
      var ox = (bw - iw) * (isNaN(pos[0]) ? .5 : pos[0]), oy = (bh - ih) * (isNaN(pos[1]) ? .5 : pos[1]);
      var left = ox + f[0] * iw, width = f[2] * iw;
      if (wrap.dataset.clamp) { var maxRight = bw * parseFloat(wrap.dataset.clamp); if (left + width > maxRight) { width = Math.max(0, maxRight - left); } }
      wrap.style.left = left + 'px';
      wrap.style.top = (oy + f[1] * ih) + 'px';
      wrap.style.width = width + 'px';
      var img = wrap.querySelector('img'); if (img) { img.style.width = (f[2] * iw) + 'px'; img.style.maxWidth = 'none'; }
      wrap.style.overflow = wrap.dataset.clamp ? 'hidden' : '';
    });
  }
  if (covers.length) {
    covers.forEach(function (w) { var b = w.parentElement.querySelector('.cc-pop-base'); if (b && !b.complete) b.addEventListener('load', placeCovers); });
    window.addEventListener('resize', placeCovers);
    window.addEventListener('load', placeCovers);
    placeCovers();
  }


  /* Newsletter archive pagination */
  document.querySelectorAll('[data-paginate]').forEach(function (wrap) {
    var per = parseInt(wrap.dataset.paginate, 10) || 9;
    var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-item]'));
    var nav = wrap.querySelector('[data-pages]');
    var pages = Math.ceil(items.length / per);
    if (pages < 2 || !nav) return;
    function go(p, scroll) {
      items.forEach(function (it, i) { it.hidden = Math.floor(i / per) !== p; });
      nav.innerHTML = '';
      if (p > 0) nav.appendChild(btn('← ' + nav.dataset.newer, p - 1));
      var label = document.createElement('span');
      label.textContent = (p + 1) + ' / ' + pages;
      nav.appendChild(label);
      if (p < pages - 1) nav.appendChild(btn(nav.dataset.older + ' →', p + 1));
      if (scroll) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function btn(text, p) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cc-link'; b.textContent = text;
      b.style.cssText = 'border:0;background:none;cursor:pointer;min-height:44px;padding:0 8px;font-size:12px;letter-spacing:.2em;text-transform:uppercase';
      b.addEventListener('click', function () { go(p, true); });
      return b;
    }
    go(0, false);
  });
})();

/* Custom hero: sweep from pencil sketch to the finished photo */
(function () {
  var media = document.querySelector('.cc-split__media');
  if (!media || !media.querySelector('.cc-sketch, .cc-sketch-mobile, .cc-sketch-flat')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var layers = Array.prototype.slice.call(media.querySelectorAll('.cc-sketch, .cc-sketch-pop, .cc-sketch-mobile, .cc-sketch-flat'));
  function offsets() { var r = media.getBoundingClientRect(); layers.forEach(function (el) { el.style.setProperty('--off', (el.getBoundingClientRect().left - r.left) + 'px'); }); }
  function run() {
    offsets(); var w = media.getBoundingClientRect().width, t0 = null, dur = 1300, delay = media.classList.contains('cc-mask') ? 700 : 200;
    function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function step(ts) {
      if (t0 === null) t0 = ts; var t = Math.min(Math.max((ts - t0 - delay) / dur, 0), 1);
      var x = -200 + ease(t) * (w + 400); layers.forEach(function (el) { el.style.setProperty('--wx', x + 'px'); });
      if (t < 1) requestAnimationFrame(step); else media.classList.add('cc-sketch-done');
    }
    requestAnimationFrame(step);
  }
  window.addEventListener('resize', offsets);
  function start() {
    if (!('IntersectionObserver' in window)) return run();
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); run(); } }, { threshold: 0.35 });
    io.observe(media);
  }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();


/* Hero sparkles: lay the sparkle layer over the photo's cover-fit area */
(function () {
  var g = document.querySelector('.cc-glints'); if (!g) return;
  var box = g.parentElement, img = box.querySelector('img');
  function place() {
    if (!img || !img.naturalWidth) return;
    var pos = (g.dataset.pos || '50% 50%').replace('center', '50%').split(/\s+/).map(function (v) { return parseFloat(v) / 100; });
    var bw = box.clientWidth, bh = box.clientHeight, sc = Math.max(bw / img.naturalWidth, bh / img.naturalHeight);
    var iw = img.naturalWidth * sc, ih = img.naturalHeight * sc;
    g.style.left = (bw - iw) * (isNaN(pos[0]) ? .5 : pos[0]) + 'px'; g.style.top = (bh - ih) * (isNaN(pos[1]) ? .5 : pos[1]) + 'px';
    g.style.width = iw + 'px'; g.style.height = ih + 'px';
  }
  if (img && !img.complete) img.addEventListener('load', place);
  window.addEventListener('resize', place); place();
})();


/* Phone menu: tap the icon to open and tap again to close; close on outside tap or link tap */
(function () {
  var d = document.querySelector('.cc-menu-toggle'); if (!d) return;
  var s = d.querySelector('summary');
  s.addEventListener('click', function (e) { e.preventDefault(); if (d.hasAttribute('open')) d.removeAttribute('open'); else d.setAttribute('open', ''); });
  d.querySelectorAll('.cc-mobile-panel a').forEach(function (a) { a.addEventListener('click', function () { d.removeAttribute('open'); }); });
  document.addEventListener('click', function (e) { if (d.hasAttribute('open') && !d.contains(e.target)) d.removeAttribute('open'); });
})();
